class SegmentTrackingService {
    constructor($q, CoreUserService, CoreCompanyService, $analytics, ANALYTICS_CONSTANTS){
        this.$q = $q;
        this.$analytics = $analytics;
        this.ANALYTICS_CONSTANTS = ANALYTICS_CONSTANTS;

        this.companyInfoPromise = CoreCompanyService.getCurrent(true).then( company => {
            this.companyName = company.name;
        });

        this.userInfoPromise = CoreUserService.getCurrent(true).then(user => {
            this.userId = user._id;
            this.userEmail = user.email;
        });


    }

    getDefaultEvent(){
        let properties = {};

        properties[this.ANALYTICS_CONSTANTS.SOURCE] = 'webapp';
        properties[this.ANALYTICS_CONSTANTS.LABEL] = undefined;
        properties[this.ANALYTICS_CONSTANTS.MEDIA_LIST_ID] = undefined;
        properties[this.ANALYTICS_CONSTANTS.NBR_OF_CONTACTS] = undefined;
        properties[this.ANALYTICS_CONSTANTS.PARENT_TYPE] = undefined;
        properties[this.ANALYTICS_CONSTANTS.ICM_USER_ID] = undefined;

        return properties;
    }

    createMediaListEvent(mediaListId, numberOfContacts, parentType, subType){
        let obj = {};
        obj[this.ANALYTICS_CONSTANTS.MEDIA_LIST_ID] = mediaListId;
        obj[this.ANALYTICS_CONSTANTS.NBR_OF_CONTACTS] = numberOfContacts;
        obj[this.ANALYTICS_CONSTANTS.PARENT_TYPE] = parentType;
        obj.subType = subType;

        return obj;
    }

    trackEvent(eventName, mediaListId, numberOfContacts, parentType, subType){
        let thisEvent = this.getEventType(eventName),
            eventData = this.getDefaultEvent(),
            data = this.createMediaListEvent(mediaListId, numberOfContacts, parentType, subType);
            
        this.getUserInformation().then(userInfo => {
            eventData = Object.assign(eventData, userInfo, data);
            eventData[this.ANALYTICS_CONSTANTS.LABEL] = eventName;

            return this.$analytics.eventTrack(thisEvent, eventData);
        });
    }

    getUserInformation(){
        let promises = [];
        promises.push(this.companyInfoPromise);
        promises.push(this.userInfoPromise);

        return this.$q((resolve, reject)=>{
            this.$q.all(promises).then(() => {
                let info = {};
                info[this.ANALYTICS_CONSTANTS.ICM_USER_ID] = `${this.userEmail} (${this.userId}) ${this.companyName}`;
                resolve(info);
            })
            .catch(err =>{
                reject(err);
            });
        });
    }

    getEventType(eventName){
        let thisEvent = null;
        switch (eventName) {
            case 'add_contact':
                thisEvent = this.ANALYTICS_CONSTANTS.ICM_ADD_CONTACT;
                break;
            case 'remove_contact':
                thisEvent = this.ANALYTICS_CONSTANTS.ICM_REMOVE_CONTACT;
                break;
            case 'export_contact':
                thisEvent = this.ANALYTICS_CONSTANTS.ICM_EXPORT_CONTACT;
                break;
            case 'outreach_email':
                thisEvent = this.ANALYTICS_CONSTANTS.ICM_OUTREACH_EMAIL;
                break;
            case 'import_contact':
                thisEvent = this.ANALYTICS_CONSTANTS.ICM_IMPORT_CONTACT;
                break;
            default:
                thisEvent = null;
                break;
        }

        return thisEvent;
    }
}

angular.module('MW.Influencers.SegmentTrackingService', [
    'MW.Framework.CoreUserService',
    'MW.Framework.CoreCompanyService',
    'MW.Influencers.AnalyticsService',
    'MW.Framework.AnalyticsConstants',
    'angulartics',
    'angulartics.segment.io'
])
.service('SegmentTrackingService', [
    '$q',
    'CoreUserService',
    'CoreCompanyService',
    '$analytics',
    'ANALYTICS_CONSTANTS',
    SegmentTrackingService
]);
